import React, { FunctionComponent } from 'react';
import CardInfo from '../../components/CardInfo';

const MessageToken: FunctionComponent = () => (
  <CardInfo
    title="Você receberá um código para retirar o pedido na loja"
    data-cy="show-message-token"
  >
    Para garantir a sua segurança, enviaremos o código por e-mail e WhatsApp.
    Não deixe de levar um documento com foto.
  </CardInfo>
);

export default MessageToken;
